import React from "react";
import { CheckCircleOutlined, HomeOutlined, LoadingOutlined, StopOutlined, WarningOutlined } from "@ant-design/icons";
import { Breadcrumb, Form, Input, Button, Table, Modal, Space, Tooltip } from "antd";
import "./item_wh_transfer_in.css";
import withItemWHTransferInLogic, { WithItemWHTransferInLogicProps, DataType } from "../../components/hoc_wh_transfer_in";
import ModalDataTransferOut from "./modal_data_transfer_out";
import EditTableWHIn from "./edit_table_wh_transfer_in";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { IoPrintSharp } from "react-icons/io5";
import { RiFileCloseFill } from "react-icons/ri";
import { HiOutlineDocumentCheck } from "react-icons/hi2";
import { FaPlusCircle } from "react-icons/fa";

const ItemWHTransferIn: React.FC<WithItemWHTransferInLogicProps> = ({
    columns,
    rowSelection,
    form,
    isModalOpen,
    showModal,
    handleOk,
    handleCancel,
    dataSource,
    handleDataSelect,
    isEditModalOpen,
    editingRecord,
    handleRowDoubleClick,
    handleEditOk,
    handleEditCancel,
    autosaveStatus,
    onValuesChange,
    handleSubmit,
    isSubmitting,
    isSubmitted,
    handlePrint,
    isPrinting,
    isReportModalOpen,
    handleReportModalCancel
}) => {
    const Printbtn = IoPrintSharp as React.ComponentType<any>;
    const Voidbtn = IoIosCloseCircleOutline as React.ComponentType<any>;
    const Closebtn = RiFileCloseFill as React.ComponentType<any>;
    const Submitbtn = HiOutlineDocumentCheck as React.ComponentType<any>;
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };
    const transOutNo = Form.useWatch('trans_out_no', form);

    return (

        <div id="iau9" style={transformStyle}>
            <div className="gjs-grid-row" id="ispsc">
                <div className="gjs-grid-column" id="iel6w">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/data_wh_transfer_in",
                                title: (
                                    <>
                                        <span>Data WH Transfer In</span>
                                    </>
                                ),
                            },
                            {
                                title: "Item WH Transfer In",
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="uuirn82">
                <div className="gjs-grid-column" id="ooep28">
                    <Button className="gr-button" >
                        <FaPlusCircle style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        New
                    </Button>
                    <Button className="gr-button" onClick={handleSubmit} disabled={isSubmitting || isSubmitted} loading={isSubmitting}>
                        <Submitbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Submit
                    </Button>
                    <Button className="gr-button" >
                        <Voidbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Void
                    </Button>
                    <Button className="gr-button" onClick={handlePrint} loading={isPrinting} disabled={isPrinting}>
                        <Printbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Print
                    </Button>
                    <Space style={{ marginLeft: '10px' }}>
                        {autosaveStatus === 'processing' && (
                            <Tooltip title="Autosave sedang berjalan...">
                                <LoadingOutlined style={{ color: '#1890ff' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'error' && (
                            <Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
                                <WarningOutlined style={{ color: '#ff4d4f' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'stopped' && (
                            <Tooltip title="Autosave Stopped">
                                <StopOutlined style={{ color: '#bfbfbf' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'idle' && (
                            <Tooltip title="Autosave berhasil.">
                                <CheckCircleOutlined style={{ color: '#52c41a' }} />
                            </Tooltip>
                        )}
                    </Space>
                </div>
            </div>


            <div className="gjs-grid-row" id="i1p0k">
                <div className="gjs-grid-column" id="iwg5z">
                    <Form
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '170px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                        form={form}
                        onValuesChange={onValuesChange}
                    >
                        <Form.Item
                            label="Created"
                            name="created"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Transfer In Status"
                            name="status"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Transfer In No"
                            name="trans_in_no"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Transfer In Date"
                            name="trans_in_date"
                            style={{
                                marginBottom: "5px", width: "70%"
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <div className="grid2">
                            <Form.Item
                                label="Transfer Out No"
                                style={{ marginBottom: "5px", width: "500px" }} >
                                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    <Form.Item
                                        name="trans_out_no"
                                        noStyle
                                        style={{ width: "100%" }}>
                                        <Input
                                            style={{ width: "100%" }}
                                            readOnly
                                        />
                                    </Form.Item>
                                    <Button
                                        type="primary"
                                        id="modal_data_transfer_out"
                                        onClick={showModal}
                                        disabled={!!transOutNo}
                                        icon={
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "40px", height: "20px" }}>
                                                <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                                <path fillRule="evenodd" d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z" clipRule="evenodd" />
                                                <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                            </svg>}
                                    />
                                </div>
                            </Form.Item>
                        </div>
                        <Form.Item
                            label="Transfer Out Date"
                            name="trans_out_date"
                            style={{
                                marginBottom: "5px", width: "70%"
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <div className="grid2">
                            <Form.Item
                                label="Transfer Request No"
                                name="trans_request_no"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Transfer Request Date"
                                name="trans_request_date"
                                style={{
                                    marginBottom: "5px", width: "70%"
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                        </div>
                        <div className="grid2">
                            <label style={{ fontWeight: 600 }}> Request From </label>
                            <Form.Item
                                label="Warehouse Name"
                                name="warehouse_name_from"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Warehouse Code"
                                name="warehouse_code_from"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                        </div>
                        <div className="grid2">
                            <label style={{ fontWeight: 600 }}> Request To </label>
                            <Form.Item
                                label="Warehouse Name"
                                name="warehouse_name_to"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Warehouse Code"
                                name="warehouse_code_to"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Purpose"
                                name="purpose"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input.TextArea rows={4} placeholder="" readOnly />
                            </Form.Item>
                        </div>
                        <div className="grid2">
                            <label style={{ fontWeight: 600 }}> Approval </label>
                            <Form.Item
                                label="Approval By"
                                name="approval"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Approval Date"
                                name="approval_date"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Approval Remark"
                                name="approval_remark"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input.TextArea rows={4} placeholder="" readOnly />
                            </Form.Item>
                        </div>
                    </Form>
                </div>
            </div >

            < div className="gjs-grid-row" id="irzty" >
                <div className="gjs-grid-column" id="ixnwg">
                    <Table<DataType>
                        rowSelection={rowSelection}
                        columns={columns}
                        dataSource={dataSource}
                        scroll={{ x: 900 }}
                        onRow={(record) => {
                            return {
                                onDoubleClick: () => {
                                    handleRowDoubleClick(record);
                                },
                            };
                        }}
                    />
                </div>
            </div >
            <Modal
                title="Data Transfer Out"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                width={1000}
                footer={null}
            >
                <ModalDataTransferOut isOpen={isModalOpen} onRowDoubleClick={handleDataSelect} />
            </Modal>
            <Modal
                title="Edit Item Transfer In"
                className="modal-edit-wh-in"
                open={isEditModalOpen}
                onCancel={handleEditCancel}
                width={400}
                footer={null}
            >
                <EditTableWHIn
                    record={editingRecord}
                    onFinish={handleEditOk}
                    onCancel={handleEditCancel}
                    warehouseCodeTo={form.getFieldValue('warehouse_code_to')} />
            </Modal>
            <Modal
                title="Print Preview - WH Transfer In"
                open={isReportModalOpen}
                onCancel={handleReportModalCancel}
                footer={null}
                width={1100}
                destroyOnClose
            >
                <div id="sti-viewer-container-wh-in" style={{ width: '100%', minHeight: '75vh' }} />
            </Modal>
        </div >
    );
};

export default withItemWHTransferInLogic(ItemWHTransferIn);
